import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const VoiceCloning = () => {
	const block = document.querySelectorAll(".voice-cloning");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();

	block.forEach((el) => {
		const cursor = el.querySelector(".voice-cloning__cursor");
		const inner = el.querySelector(".voice-cloning__list-wrap");
		const wrap = el.querySelector(".voice-cloning__wrap");
		const progressBar = el.querySelector(".voice-cloning__progress-bar");
		// let inited = false;

		// const initFrames = () => {
		// 	if (!inited) {
		// 		el.querySelectorAll("iframe").forEach((frame) => {
		// 			frame.setAttribute("src", frame.getAttribute("data-src"));
		// 		});
		// 		inited = true;
		// 	}
		// };

		// gsap.timeline({
		// 	scrollTrigger: {
		// 		trigger: el,
		// 		start: "top bottom",
		// 		onEnter: () => {
		// 			initFrames();
		// 		},
		// 		onEnterBack: () => {
		// 			initFrames();
		// 		}
		// 	}
		// });

		mm.add("(min-width: 1024px)", () => {
			if (cursor) {
				gsap.set(cursor, { scale: 0, autoAlpha: 0 });

				const moveCursor = function (event) {
					if (event.target.closest(".voice-cloning__list-video")) {
						gsap.to(cursor, { scale: 0, autoAlpha: 0, duration: 0.4 });
					} else {
						gsap.to(cursor, {
							scale: 1,
							autoAlpha: 1,
							left: event.pageX - el.offsetLeft,
							top: event.pageY - el.offsetTop,
							duration: 0.4
						});
					}
				};
				el.addEventListener("mouseover", (e) => {
					document.addEventListener("mousemove", moveCursor, false);
				});
				el.addEventListener("mouseleave", (e) => {
					document.removeEventListener("mousemove", moveCursor, false);
					gsap.to(cursor, { scale: 0, autoAlpha: 0, duration: 0.5 });
				});
			}
		});

		const handleScrollProgress = () => {
			const totalW = inner.scrollWidth - wrap.offsetWidth;
			const scrollPosition = inner.scrollLeft;
			const pProgress = (scrollPosition / totalW) * 100;
			let progressValue = pProgress < 5 ? "5%" : pProgress;
	
			progressBar.style.width = `${progressValue}%`;
		};

		inner.addEventListener("scroll", handleScrollProgress, { passive: true });
	});
};

export default VoiceCloning;
